import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchRoomNotes as fetchRoomNotesAction,
  fetchBookingNotes as fetchBookingNotesAction,
  addBookingNote as addBookingNoteAction,
  resolveBookingNote as resolveBookingNoteAction,
  archiveBookingNote as archiveBookingNoteAction,
  restoreBookingNote as restoreBookingNoteAction,
  editBookingNote as editBookingNoteAction,
  fetchOtherBookingNotes as fetchOtherBookingNotesAction,
  addRoomNote as addRoomNoteAction,
  editRoomNote as editRoomNoteAction,
  archiveRoomNote as archiveRoomNoteAction,
  restoreRoomNote as restoreRoomNoteAction,
  fetchNotes as fetchNotesAction,
  fetchSalesNotes as fetchSalesNotesAction,
  addSalesNote as addSalesNoteAction,
  archiveSalesNote as archiveSalesNoteAction,
  restoreSalesNote as restoreSalesNoteAction,
  resolveSalesNote as resolveSalesNoteAction,
  editSalesNote as editSalesNoteAction
} from './';

import {
  fetchBookingNotes,
  addBookingNote,
  resolveBookingNote,
  archiveBookingNote,
  restoreBookingNote,
  editBookingNote,
  fetchOtherBookingNotes,
  fetchRoomNotes,
  addRoomNote,
  editRoomNote,
  archiveRoomNote,
  restoreRoomNote,
  fetchNotes,
  fetchSalesNotes,
  addSalesNote,
  archiveSalesNote,
  restoreSalesNote,
  resolveSalesNote,
  editSalesNote
} from 'sdk/notes';

function* notesSaga() {
  yield all([
    createFetchSagaLatest(fetchBookingNotesAction, fetchBookingNotes),
    createFetchSagaLatest(fetchRoomNotesAction, fetchRoomNotes),
    createFetchSagaLatest(fetchOtherBookingNotesAction, fetchOtherBookingNotes),
    createFetchSagaLatest(fetchNotesAction, fetchNotes),
    createFetchSagaLatest(fetchSalesNotesAction, fetchSalesNotes),

    createPostSagaLatest(addBookingNoteAction, addBookingNote),
    createPostSagaLatest(archiveBookingNoteAction, archiveBookingNote),
    createPostSagaLatest(restoreBookingNoteAction, restoreBookingNote),
    createPostSagaLatest(addRoomNoteAction, addRoomNote),
    createPostSagaLatest(archiveRoomNoteAction, archiveRoomNote),
    createPostSagaLatest(restoreRoomNoteAction, restoreRoomNote),
    createPostSagaLatest(editBookingNoteAction, editBookingNote),
    createPostSagaLatest(editRoomNoteAction, editRoomNote),
    createPostSagaLatest(resolveBookingNoteAction, resolveBookingNote),
    createPostSagaLatest(addSalesNoteAction, addSalesNote),
    createPostSagaLatest(archiveSalesNoteAction, archiveSalesNote),
    createPostSagaLatest(restoreSalesNoteAction, restoreSalesNote),
    createPostSagaLatest(resolveSalesNoteAction, resolveSalesNote),
    createPostSagaLatest(editSalesNoteAction, editSalesNote)
  ]);
}

export default notesSaga;
